import { Chip } from 'ui';

import { RiskScores } from '../../types';
import { formatRiskScoreName } from './formatRiskScore';
import { getChipColor } from './getChipColor';

export const RiskScoreChip = ({ riskScore }: { riskScore: RiskScores | null }) => {
  const chipColor = getChipColor(riskScore);
  const label = formatRiskScoreName(riskScore);
  return <Chip size="small" label={label} color={chipColor} title={label} />;
};
